import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 3a6.5 6.5 0 0 1 6.34 5.06A6 6 0 0 1 17 20H5.5a4.5 4.5 0 0 1-.32-8.99A6.52 6.52 0 0 1 11.5 3Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'cloud');
export default IconComponent;